import { useMutation } from '@tanstack/react-query';
import {
  invalidateOffboardings,
  updateOffboarding,
} from '../../services/offboardings';
import { invalidateMarketingData } from '../../services/marketing';
import {
  OffboardingMutationResult,
  UpdateOffboardingPayload,
} from '../../types/offboardings';

function useUpdateOffboarding(
  options: {
    onMutate?: () => void;
    onSuccess?: (result: OffboardingMutationResult) => void;
    onError?: (error: unknown) => void;
    onSettled?: () => void;
  } = {},
) {
  return useMutation({
    mutationFn: ({
      offboardingId,
      payload,
    }: {
      offboardingId: string;
      payload: UpdateOffboardingPayload;
    }) => updateOffboarding(offboardingId, payload),
    onMutate: options.onMutate,
    onSuccess: async result => {
      await invalidateOffboardings(result.businessId, result.id);
      if (result.hadLinkedCampaign) {
        await invalidateMarketingData();
      }
      options.onSuccess?.(result);
    },
    onError: options.onError,
    onSettled: options.onSettled,
  });
}

export default useUpdateOffboarding;
